var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[_c('Mail',{attrs:{"emails_list":_vm.mandat.emails,"attached_objects":[
      {
       object: 'NoteCloture',
       id: _vm.mandat_id
      }
    ],"body":_vm.body,"subject":_vm.subject},on:{"close":function($event){return _vm.$emit('close', $event)}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }